import { Grid, useMediaQuery } from '@mui/material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import DialogButton from './DialogButton';
import NewPurchaseDialog from './NewPurchaseDialog';
import NewRental from '../NewRental';
import { useScopeCheck } from '../../../../reusable-components/scopes';
import { useDispatch, useSelector } from '../../../../redux/store';
import { getOrderingFacilities } from '../../../../redux/slices/orderSheet';
import { setIsAddingNewTicket } from '../../../../redux/slices/tickets';

NewDialogButtons.propTypes = {
  openDialog: PropTypes.bool,
  setOpenDialog: PropTypes.func,
};

export default function NewDialogButtons({openDialog, setOpenDialog}) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: { facilities } } = useSelector((state) => state.orderSheet);
  const { isAddingNewTicket } = useSelector((state) => state.tickets);
  const canSubmitRentals = useScopeCheck(['Rental-Order-Submit'], true);
  const canSubmitOrders = useScopeCheck(['Create-Order'], true);

  const [openPurchaseDialog, setOpenPurchaseDialog] = useState(false);
  const [openRentalDialog, setOpenRentalDialog] = useState(false);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const handlePurchaseClick = () => {
      setOpenPurchaseDialog(true);
  };

  const handleRentalClick = () => {
      setOpenRentalDialog(true);
  };

  const handleClosePurchaseDialog = () => {
    setOpenPurchaseDialog(false);
    setOpenDialog(false);
  };

  const handleNewTicketClick = () => {
    navigate('/dashboard/tickets');
    dispatch(setIsAddingNewTicket(true));
    setOpenDialog(false);
  }

  useEffect(() => {
    if (openDialog && !facilities?.length && canSubmitOrders) dispatch(getOrderingFacilities());
  }, [dispatch, facilities, openDialog]);
  
  return <Grid container spacing={1} direction="row" justifyContent="space-evenly" alignItems="center">
      <DialogButton 
        handleClick={handlePurchaseClick}
        disabled={!canSubmitOrders}
        sx={canSubmitOrders ? {} : { opacity: .6, ":hover": { "bgcolor": "unset !important" }}}
        buttonDescription={"Click here to begin new purchase"}
        buttonLabel={"Purchasing"}
        tooltipText={canSubmitOrders ? "" : "Order permission needed for this function"}
        icon={"clarity:store-line"}
      />
      <NewPurchaseDialog openPurchaseDialog={openPurchaseDialog} handleClosePurchaseDialog={handleClosePurchaseDialog} />
      <DialogButton
        handleClick={handleRentalClick}
        buttonDescription={"Click here to begin new rental"}
        buttonLabel={"Rentals"}
        icon={"carbon:hospital-bed"}
      />
      {openRentalDialog && (
        <NewRental
          openRentalDialog={openRentalDialog}
          setOpenRentalDialog={setOpenRentalDialog}
          openNewOrderDialog={openDialog}
          setOpenNewOrderDialog={setOpenDialog}
        />
      )}
    {
      isMobile && !isAddingNewTicket && <DialogButton
        handleClick={handleNewTicketClick}
        disabled={false}
        sx={{}}
        buttonDescription={"Click here to open new ticket"}
        buttonLabel={"New Ticket"}
        tooltipText={""}
        icon={"fa7-regular:message"}
      />
    }
  </Grid>;
}